function CanvasElements(props) {
    let divideBy = 2;
    if (props.resolutionSize === 2) {
        divideBy = 1;
    }
    let canvasElements =
        props.canvasBmpArray.map((reference, index) => {
            if (props.svgComponentArray[index] !== undefined) {
                return <canvas className="canvasForSVG"
                    id={props.svgComponentArray[index].fileName}
                    ref={reference}
                    width={props.svgComponentArray[index].width / divideBy}
                    height={props.svgComponentArray[index].height / divideBy}
                />
            }
            else return null;
        }
        )
    return (
        <div>
            {canvasElements}
        </div>
    )
}

export default CanvasElements;